<template>
  <div class="image-uploader">
    <input
      type="file"
      accept="image/*"
      :class="'image-edit-upload section-id-' + id"
      @change="handleUpload"
    />
  </div>
</template>

<script>
export default {
  name: "ImageUploader",
  props: {
    id: Number
  },
  methods: {
    handleUpload: function(event) {
      const uploader = document.querySelector(
        ".image-edit-upload.section-id-" + this.id
      );
      console.log(uploader.files);
    }
  }
};
</script>

<style lang="scss" scoped>
.image-edit-upload {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/ImageUploader.vue